import { Divider, type DividerProps } from '../Divider';

export type OptionDividerProps = DividerProps;

const OptionDivider = (props: OptionDividerProps) => <Divider {...props} />;

export default OptionDivider;
